import type RootState from 'app-components/utils/redux-store/rootState';

import { PAYMENT_METHODS_REDUCER_KEY } from './paymentMethodsReducer';
import type { PaymentMethodsStore } from './paymentMethodsTypes';

type State = Pick<RootState, typeof PAYMENT_METHODS_REDUCER_KEY>;
type PaymentMethodsById = PaymentMethodsStore['resourcesById'];

export const getStore = (state: State): PaymentMethodsStore => state[PAYMENT_METHODS_REDUCER_KEY];
export const getIsLoading = (state: State): boolean => getStore(state).isLoading;
export const getLoadPending = (state: State): boolean => getStore(state).loadPending;
export const getError = (state: State): unknown => getStore(state).error;
export const getResourcesById = (state: State): PaymentMethodsById => getStore(state).resourcesById;
